<div id="nav">
    <a href="http://itec.unice.fr"><h1>ITEC</h1></a>
    <a routerLink="/infos"  id="btn-info">Infos</a>
    <a routerLink="/app" id="btn-info">Application</a>
</div>

<router-outlet></router-outlet>

